import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Texto de ayuda estándar bajo los campos de hora del día: indica que se
 * ingresa en formato 24 horas, sin importar la configuración regional del equipo.
 */
@Component({
  selector: 'app-hora-hint',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <small
      [id]="id()"
      class="block mt-1 text-xs text-gray-500 dark:text-gray-400"
    >
      {{ texto() }}
    </small>
  `,
})
export class HoraHintComponent {
  /** Id único del texto, para `aria-describedby` cuando el campo lo permita. */
  readonly id = input.required<string>();
  readonly texto = input<string>('Formato 24 horas (HH:mm)');
}
